<template>
  <div class="modal_content">
    <div class="title_label">
      {{titleLabel}}
    </div>
    <input class='detail_input_field' type="password" @input="inputUpdate">
  </div>
</template>

<script>

export default {
  props: {
    titleLabel: String
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    inputUpdate (e) {
      this.$emit('inputUpdate', e)
    }
  }
}
</script>
<style scoped>
.detail_input_field {
  width: calc(100% - 10px);
}
.title_label {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/modalwindowComponents/passwordInputSection.vue